import { i18n } from "@/i18n";

export default {
  path: "/apprentice",
  name: "ApprenticeDashboard",
  redirect: { name: "ApprenticeContractList" },
  component: () => import(/* webpackChunkName: "admin" */ "@/views/Apprentice/ApprenticeLayoutView.vue"),
  meta: {
    breadcrumb: true,
    authRequired: true,
    title: i18n.global.t("myContracts"),
  },
  children: [
    {
      path: "contract",
      name: "ApprenticeContractList",
      component: () => import(/* webpackChunkName: "admin" */ "@/views/Apprentice/ApprenticeContractListView.vue"),
      meta: {
        title: i18n.global.t("myContracts"),
        breadcrumb: true,
      },
    },
  ],
};
